export const ProductTypeOfFormula = [
  'Fórmulas de partida',
  'Fórmulas de segmento',
  'Fórmulas de primeira infância',
  'Fórmulas de rotina'
];
